import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { AiOutlineMore } from "react-icons/ai";
import SearchableSelect from "../../components/selectForm";
import useDebounce from "../../hooks/useDebounce";
import { useCategories } from "../../categorys/contract/index";
import FormInfo from "./form/info";
// import { commonCall } from "../../api/common";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import { useSaleContractStatement } from "../../hooks/useContractStatement";
import { useSearchParams } from "react-router-dom";

const TableSaleContractStatement = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [searchParams] = useSearchParams();

  const employeeIdParam =
    searchParams.get("employee") || searchParams.get("employeeId");
  const saleAreaIdParam =
    searchParams.get("saleArea") || searchParams.get("saleAreaId");
  const saleBlockIdParam =
    searchParams.get("saleBlock") || searchParams.get("saleBlockId");
  const statusParam = searchParams.get("status");
  const branchIdParam = searchParams.get("branchId");
  const projectIdParam = searchParams.get("projectId");
  const startTimeParam = searchParams.get("startTime");
  const endTimeParam = searchParams.get("endTime");
  const agentIdParam = searchParams.get("agentId");

  const [isEdit, setIsEdit] = useState(false);
  const [search, setSearch] = useState("");
  const [projectId, setProjectId] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [status, setStatus] = useState(null);
  const [apartmentId, setApartmentId] = useState([]);
  const [customerId, setCustomerId] = useState(null);
  const [zIndex, setZIndex] = useState(1);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [agentId, setAgentId] = useState(null);

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    contractData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useSaleContractStatement(
    debouncedSearchTerm,
    projectId || null,
    employeeId || null,
    status || null,
    apartmentId,
    customerId,
    startDate || null,
    endDate || null,
    saleBlockId || null,
    saleAreaId || null,
    agentId || null
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );

  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee]
  );
  const apartments = useMemo(
    () => formatEntries(constantData?.apartments),
    [constantData?.apartments]
  );
  const customers = useMemo(
    () => formatEntries(constantData?.customer),
    [constantData?.customer]
  );

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea]
  );
  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock]
  );

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Trạng thái",
        key: "status",
      },
      {
        label: "Ảnh UNC",
        key: "delegationImage",
      },
      {
        label: "Ảnh Phiếu Tính Giá",
        key: "priceSheetImage",
      },
      {
        label: "Ảnh HDMB",
        key: "salesContractImages",
      },
      // {
      //   label: "Mã HĐMB",
      //   key: "code",
      // },
      {
        label: "Dự án",
        key: "name",
      },
      {
        label: "Mã sản phẩm (mã căn)",
        key: "apartment",
      },
      // {
      //   label: "Tên sản phẩm",
      //   key: "nameApartment",
      // },
      {
        label: "Tên khách hàng",
        key: "customer",
      },
      {
        label: "Ngày ký hợp đồng",
        key: "time",
      },
      {
        label: "Ngày đóng tiền HĐMB",
        key: "priceTime",
      },
      // {
      //   label: "Phiếu tính giá",
      //   key: "invoice",
      // },
      // {
      //   label: "Phương thức thanh toán",
      //   key: "paymentMethod",
      // },
      {
        label: "Người chuyển HĐMB",
        key: "creator",
      },
      {
        label: "Khối",
        key: "saleBlock",
      },
      {
        label: "Vùng",
        key: "saleArea",
      },
      // {
      //   label: "Đại lý",
      //   key: "agentName",
      // },
      {
        label: "Ngày chuyển HĐMB",
        key: "createdAt",
      },
    ],
    data: contractData,
  };

  useEffect(() => {
    if (startTimeParam && endTimeParam) {
      const start = new Date(startTimeParam);
      const end = new Date(endTimeParam);
      setDateRange([start, end]);
    }
    if (saleBlockIdParam) setSaleBlockId(saleBlockIdParam);
    if (saleAreaIdParam) setSaleAreaId(saleAreaIdParam);
    if (employeeIdParam) setEmployeeId(employeeIdParam);
    if (agentIdParam) setAgentId(agentIdParam);
    if (projectIdParam && projects?.length) {
      const ids = projectIdParam.split(",").map((id) => id.trim());
      const selectedProjects = projects.filter((item) =>
        ids.includes(item.key)
      );
      const selectedIds = selectedProjects.map((item) => item.key);
      console.log(selectedIds);
      setProjectId(selectedIds);
    }
  }, [
    saleBlockIdParam,
    saleAreaIdParam,
    employeeIdParam,
    projectIdParam,
    projects,
    startTimeParam,
    endTimeParam,
  ]);

  const initialSelectedSaleBlock = useMemo(() => {
    if (!saleBlockIdParam || !saleBlocks?.length)
      return { key: 0, value: "Chọn khối" };
    // if (saleBlockIdParam) setSaleBlockId(saleBlockIdParam);
    return (
      saleBlocks.find((item) => item.key === saleBlockIdParam) || {
        key: 0,
        value: "Chọn khối",
      }
    );
  }, [saleBlockIdParam, saleBlocks]);

  const initialSelectedEmployee = useMemo(() => {
    if (!employeeIdParam || !employees?.length)
      return { key: 0, value: "Tất cả nhân viên" };
    // if (employeeIdParam) setEmployeeId(employeeIdParam);
    return (
      employees.find((item) => item.key === employeeIdParam) || {
        key: 0,
        value: "Tất cả nhân viên",
      }
    );
  }, [employeeIdParam, employees]);

  const initialSelectedSaleArea = useMemo(() => {
    if (!saleAreaIdParam || !saleAreas?.length)
      return { key: 0, value: "Chọn vùng" };
    // if (saleAreaIdParam) setSaleAreaId(saleAreaIdParam);
    return (
      saleAreas.find((item) => item.key === saleAreaIdParam) || {
        key: 0,
        value: "Chọn vùng",
      }
    );
  }, [saleAreaIdParam, saleAreas]);

  const initialSelectedProject = useMemo(() => {
    if (!projectIdParam || !projects?.length) return [];

    const ids =
      typeof projectIdParam === "string"
        ? projectIdParam.split(",").map((id) => id.trim())
        : [];

    const selectedProjects = projects.filter((item) => ids.includes(item.key));
    const selectedIds = selectedProjects.map((item) => item.key);
    // setProjectId(selectedIds);
    return selectedProjects.length > 0 ? selectedProjects : [];
  }, [projectIdParam, projects]);

  const handlePopup = (type, e) => {
    if (type) {
      setDataEdit(e?.edit);
    } else {
      setDataEdit(e?.detail);
    }

    setIsEdit(type);
    onOpen();
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Nhập mã, tên HĐMB, tên dự án..."
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                {/* <SearchableSelectMulti
                isShowSearch={false}
                options={statusDatas}
                // initialSelectedOption={{
                //   key: null,
                //   value: "Trạng thái",
                // }}
                placeholder={"Trạng thái"}
                setValue={setStatus}
              /> */}
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={apartments}
                  // initialSelectedOption={[{ key: 0, value: "Chọn mã căn" }]}
                  placeholder={"Chọn mã căn"}
                  setValue={setApartmentId}
                />
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={projects}
                  // initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                  placeholder={"Chọn dự án"}
                  setValue={setProjectId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={customers}
                  initialSelectedOption={{ key: 0, value: "Chọn khách hàng" }}
                  setValue={setCustomerId}
                />
                <InputGroup w={"100%"} maxW={"300px"} zIndex={zIndex}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    onFocus={() => {
                      setZIndex(3);
                    }}
                    onBlur={() => {
                      setZIndex(1);
                    }}
                    isClearable={true}
                    placeholderText="Ngày ký HĐMB từ ngày - đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
                <SearchableSelect
                  isShowSearch={true}
                  options={employees}
                  initialSelectedOptionParam={{
                    key: 0,
                    value: "Chọn người chuyển HĐMB",
                  }}
                  initialSelectedOption={initialSelectedEmployee}
                  setValue={setEmployeeId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleBlocks}
                  // initialSelectedOption={{ key: 0, value: "Chọn khối" }}
                  initialSelectedOptionParam={{ key: 0, value: "Chọn khối" }}
                  initialSelectedOption={initialSelectedSaleBlock}
                  setValue={setSaleBlockId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleAreas}
                  initialSelectedOptionParam={{ key: 0, value: "Chọn vùng" }}
                  initialSelectedOption={initialSelectedSaleArea}
                  setValue={setSaleAreaId}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "delegationImage") {
                          width = "5%";
                          textAlign = "center";
                        } else if (e.key === "priceSheetImage") {
                          width = "5%";
                          textAlign = "center";
                        } else if (e.key === "salesContractImages") {
                          width = "5%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "status") {
                          width = "auto";
                          textAlign = "start";
                        } else if (e.key === "apartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "nameApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "name") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "price") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "codeProduct") {
                          width = "10%";
                          textAlign = "start";
                        } else {
                          width = "15%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td
                              p={"16px 0px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                  p={0}
                                >
                                  <AiOutlineMore fontSize={"20px"} w="20px" />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td
                              p={"16px 0px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "delegationImage") {
                                width = "5%";
                                textAlign = "center";
                              } else if (keyvalue === "priceSheetImage") {
                                width = "5%";
                                textAlign = "center";
                              } else if (keyvalue === "salesContractImages") {
                                width = "5%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "status") {
                                width = "auto";
                                textAlign = "start";
                              } else if (keyvalue === "name") {
                                width = "10%";
                                textAlign = "start";
                                whiteSpace = "normal";
                                widthText = "118px";
                              } else if (keyvalue === "apartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "nameApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "price") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "codeProduct") {
                                width = "10%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "timeDelivery" ||
                                keyvalue === "timeStart" ||
                                keyvalue === "timeEnd"
                              ) {
                                width = "5%";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                  bg={
                                    rowIndex % 2 === 0
                                      ? "var(--color-main)"
                                      : "var(--fill-avatar)"
                                  }
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {keyvalue === "status"
                                      ? formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          e.code,
                                          null,
                                          e.id
                                        )
                                      : formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          e.code
                                        )}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {!isEdit && (
        <FormInfo
          isOpen={isOpen}
          onClose={onClose}
          defaultValues={dataEdit}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default TableSaleContractStatement;
